import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=bf51ddf0&"
import script from "./Notice.vue?vue&type=script&lang=ts&"
export * from "./Notice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf51ddf0')) {
      api.createRecord('bf51ddf0', component.options)
    } else {
      api.reload('bf51ddf0', component.options)
    }
    module.hot.accept("./Notice.vue?vue&type=template&id=bf51ddf0&", function () {
      api.rerender('bf51ddf0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Notice.vue"
export default component.exports